import { Button, Dropdown, Modal } from "antd";
import { useRef, useState } from "react";
import "./CreateFolderModal.scss";
import "./ChangeLocationModal.scss";
import DesignApi from "../../api/DesignApi";
import { useRecoilState } from "recoil";
import { locationsState } from "../../state/atoms";
import { DownOutlined } from "@ant-design/icons";
import { DesignDto, LocationDto } from "../../generated/dashboard-client";

export interface ChangeLocationModalProps {
  isVisible: boolean;
  id: string;
  design: DesignDto;
  onClose: (id: string, locationId: number, saved: boolean) => void;
}

export function ChangeLocationModal({
  isVisible,
  id,
  design,
  onClose,
}: ChangeLocationModalProps) {
  const [locations] = useRecoilState(locationsState);
  const [removing, setRemoving] = useState(false);
  const [locationId, setLocationId] = useState(0);
  const [locationName, setLocationName] = useState("");
  const dropdownButton = useRef<HTMLDivElement>(null);

  function assign() {
    setRemoving(true);

    if (design.upload) {
      DesignApi.changeLocationPDFUpload(id, locationId)
        .then(() => {
          setRemoving(false);
          onClose(id, locationId, true);
        })
        .catch(() => {
          setRemoving(false);
        });
    } else {
      DesignApi.changeLocation(id, locationId)
      .then(() => {
        setRemoving(false);
        onClose(id, locationId, true);
      })
      .catch(() => {
        setRemoving(false);
      });
    }
  }

  function setLocation(loc: LocationDto) {
    setLocationId(loc.internalId!);
    setLocationName(loc.name!);
  }

  function hideDropdown() {
    dropdownButton.current?.click();
  }

  const menu = (
    <div className={"loc-drop-menu change-loc-modal"} onClick={hideDropdown}>
      <ul>
        {locations.map((it) => (
          <li key={it.id} onClick={() => setLocation(it)}>
            <div className={"lk"}>
              <h6>{it.name}</h6>
              <p>
                {it.address} {it.city}
                {it.state !== "" && <span>, {it.state}</span>}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <Modal
      className={"clean one"}
      visible={isVisible}
      onCancel={() => onClose(id, locationId, false)}
    >
      <header>
        <h2>Move design to a new location</h2>
      </header>

      <Dropdown
        className={"loc-drop change-loc-modal"}
        overlay={menu}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
        trigger={["click"]}
      >
        <Button
          type={"link"}
          size={"large"}
          onClick={(e) => e.preventDefault()}
          ref={dropdownButton}
        >
          {locationName !== "" && <span>{locationName}</span>}
          {locationName === "" && <span>Change Location</span>}
          <DownOutlined className={"carr"} />
        </Button>
      </Dropdown>

      <footer>
        <Button size={"large"} onClick={() => onClose(id, locationId, false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={assign}
          loading={removing}
          disabled={locationId===0}
        >
          Move
        </Button>
      </footer>
    </Modal>
  );
}
